import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { HelpSection } from '../../types/Cashier';
import { CashierFlowType } from '../../types/Cashier';

import { container, content, label, wrapper } from './HelpSectionContainer.scss';
import { getHelpContent } from './helpContent';

interface Props {
  helpSection?: HelpSection;
}

const HelpSectionContainer: React.FC<Props> = ({ helpSection }) => {
  const {
    data: { cashierFlow }
  } = useWizardContext();

  const showHelp = [
    CashierFlowType.FirstDeposit,
    CashierFlowType.FirstManageCurrencies,
    CashierFlowType.FirstP2pTransfer,
    CashierFlowType.FirstPaymentMethods,
    CashierFlowType.FirstTransactionHistory,
    CashierFlowType.FirstWithdraw
  ].includes(cashierFlow);

  return showHelp ? (
    <div className={wrapper}>
      <div className={container}>
        <div className={label}>
          {helpSection ? (
            <Translation {...helpSection.title} />
          ) : (
            <Translation {...getHelpContent(cashierFlow).title} />
          )}
        </div>
        <div className={content}>
          {helpSection ? (
            helpSection.body
          ) : (
            <Translation
              {...(getHelpContent(cashierFlow).text as TranslationTag)}
              values={{
                a: getHelpContent(cashierFlow).link
              }}
            />
          )}
        </div>
      </div>
    </div>
  ) : null;
};
export default HelpSectionContainer;
